import { Button, Divider, Form, Input, Table, message } from "antd";
import { layoutForms, toEnglishDigits } from "../../../component/utility";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";
import { useEffect } from "react";

const RegisterOpgNumberingTeeth = (props) => {
  const [form] = Form.useForm();
  const ColumnsAnalyses = [
    {
      title: "User ID",
      dataIndex: "UserID",
      key: "PatieUserIDntId",
      render: (object, item) => {
        return <div>{item.id}</div>;
      },
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      render: (object, item) => {
        return <div>{item.name}</div>;
      },
    },
  ];
  useEffect(() => {
    _getList();
  }, []);

  const _getList = async () => {
    let url = Url.ListOpgNumberingUser;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  const _onFinishForm = async (values) => {
    values.userName = toEnglishDigits(values.userName);
    values.password = toEnglishDigits(values.password);

    console.log(values);
    let url = Url.registerOpgNumberingUser;

    let res = await props.actions.CallCoreServicesActionWithToken(url, values);

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    form.resetFields();
    message.success("با موفقیت ثبت شد");
    _getList();
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ alignSelf: "center", width: "80%" }}>
        <Divider>ثبت کاربر آنالیز پانورامیک</Divider>
        <Form
          {...layoutForms}
          form={form}
          name="register"
          onFinish={_onFinishForm}
        >
          <Form.Item
            name="Name"
            label="Name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="userName"
            label="userName"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="password"
            label="password"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button onClick={() => form.submit()}>ثبت دانشجو</Button>
          </Form.Item>
        </Form>

        <Divider>لیست افراد</Divider>
        <Table
          columns={ColumnsAnalyses}
          dataSource={
            props.coreData[Url.ListOpgNumberingUser]?.[Url.action]?.data
          }
          loading={
            props.coreData[Url.ListOpgNumberingUser]?.[Url.action]?.isFetching
          }
        />
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterOpgNumberingTeeth);
